import React, {Component} from 'react';
import {connect} from 'react-redux';
import VariablesForm from '../components/VariablesForm';
import {DATA_SETS} from '../Constants';
import './Forms.css';

const META_DATA = [
  {
    key: 'fine_fuel_load',
    displayName: 'Fine Fuel Load (t/ha)',
    min: 0,
    max: 50,
    order: 1,
    note: '1 Default taken from Modelled Total Fuel Load'
  },
  { key: 'slope', displayName: 'Slope (deg)', min: -90, max: 90, order: 2 },
  { key: 'wind_reduction_factor', displayName: 'Wind Reduction Factor (1-6)', min: 1, max: 6, order: 3 },
  {
    key: 'lag_temp_rh', displayName: 'Lag Temp & RH', order: 4,
    enum: { 'Off': 0, '2 Hrs': 2 }
  }
];
// Default no longer taken from Fuel Type
// { key: 'wind_reduction_factor', displayName: 'Wind Reduction Factor (1-6)', min: 1, max: 6, note: '2 Default taken from Phoenix Fuel Type' }

class Leaflet80Variables extends Component {
  render() {
    return <VariablesForm data_set={DATA_SETS.LEAFLET_80}
                          meta_data={META_DATA}
                          variables={this.props.variables}
                          dispatch={this.props.dispatch}/>;
  }
}

const mapStateToProps = state => {
  return {
    variables: {
      slope: state.point_data_leaflet_80.slope,
      fine_fuel_load: state.point_data_leaflet_80.fine_fuel_load,
      wind_reduction_factor: state.point_data_leaflet_80.wind_reduction_factor,
      lag_temp_rh: state.point_data_leaflet_80.lag_temp_rh
    }
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Leaflet80Variables);



// WEBPACK FOOTER //
// ./src/containers/Leaflet80Variables.js